module.exports = __webpack_public_path__ + "img/zhongtingzheng.948439d.png";